import { SectionTranslationModel } from '@/assets/locales/views/employeeProfile/sections/SectionTranslation.model.ts';

export type EmployeeProfileDevelopmentPlanSectionTranslation = SectionTranslationModel<{
  completionTitle: string;
  finished: string;
  label: string;
}>;

export const employeeProfileDevelopmentPlanSectionTranslation: EmployeeProfileDevelopmentPlanSectionTranslation =
  {
    content: {
      completionTitle: 'Stopień realizacji planu',
      finished: '{{count}} z {{total}} ukończono',
      label: 'Treść planu',
    },
    headerTitle: 'Podgląd planu rozwojowego',
    headerTitleShorter: 'Podgląd planu rozwojowego',
  };
